module.exports = __webpack_public_path__ + "img/Welcome.545ba2fe.png";